import {defineMessages} from 'react-intl';

export default defineMessages({
    failed_to_signup: {
        id: 'newsletter.bottom.failed_to_signup',
        defaultMessage: 'Não foi possível cadastrar o seu endereço de email, por favor tente novamente.',
    },
    signup_success: {
        id: 'newsletter.bottom.signup_success',
        defaultMessage: 'Email cadastrado com sucesso!',
    },
    signup_cta: {
        id: 'newsletter.bottom.signup_cta',
        defaultMessage: 'Cadastrar',
    },
    type_your_email: {
        id: 'newsletter.bottom.type_your_email',
        defaultMessage: 'Digite seu email',
    },
    title: {
        id: 'newsletter.bottom.signup_to_newsletter',
        defaultMessage: 'Cadastre-se em nossa newsletter',
    },
    subtitle: {
        id: 'newsletter.bottom.receive_best_coupons',
        defaultMessage: 'Receba os melhores cupons de desconto das maiores lojas.',
    }
});
